<template>
    <ul class="bannedwatchers list-unstyled" v-chat-scroll>
        <li class="watchers row" v-for="watcher in watchers" :key="watcher.key">
            <div class="col-10" >
                {{ watcher.nickname }} ({{ watcher.id }}) <span> : {{watcher.message}}</span> <br/>
                사유 : {{watcher.reason}}<br/>
                일자 : {{dateString(watcher.bannedAt)}}
            </div>
            <b-btn class="col-2" variant="link" size="1" @click="unban(watcher.id)">unban</b-btn>
        </li>
    </ul>
</template>
<style>
    .bannedwatchers {
        font-size: .8rem;
    }
</style>
<script>
import {
  mapGetters,
  mapState
} from 'vuex'
// import l from '@/vendor/logger'

export default {
  name: 'BannedWatchers',
  props: {
    showMessage: false
  },

  created () {
  },

  computed: {
    ...mapState('chatOption', [
      'bannedWatchers', 'filteringWords'
    ]),
    ...mapGetters('chatOption', [
      'watchers'])
  },
  methods: {
    unban (uid) {
      this.$store.dispatch('bannedWatchers/removeWatcher', uid)
    },
    dateString (ts) {
      if (ts && !isNaN(parseInt(ts))) {
        let aaaa = new Date(ts)
        return `${aaaa.getFullYear()}-${aaaa.getMonth()}-${aaaa.getDate()} ${aaaa.getHours()}:${aaaa.getMinutes()}:${aaaa.getSeconds()}`
      } else {
        return 'Invalid Date'
      }
    }
  }
}
</script>

<style scoped>

</style>
